import { render } from "./ClientEventAppendButton.vue?vue&type=template&id=8c2851d4"
import script from "./ClientEventAppendButton.vue?vue&type=script&lang=js"
export * from "./ClientEventAppendButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__